<ion-list class="ion-padding">
  <ion-item *ngIf="sales && sales.length == 0"> No sale to show</ion-item>
  <ion-item *ngIf="sales && sales.length != 0">
    <b>Date</b>          
    <div slot="end">
      <b>Total</b>
    </div>
  </ion-item>
  <ion-item *ngFor="let sale of sales" button (click)="navigate(sale.id)">
    {{ sale.datetime | salonMonsterDate: 'dddd, MMMM D, Y' }} <div slot="end">{{ sale.total | salonMonsterCurrency }}</div>
  </ion-item>
</ion-list>
